import { httpClient } from 'api/HttpClient';

export const AssetsApi = {
  LocalAppUpgrade: (ids: number[]) => {
    const data = { ids };
    const url = '/api/odata/v4/MyAssets/StartUpgradeIds';
    return httpClient.post(url, data);
  },
};
